import Button from "@mui/material/Button";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { useNavigate } from "infrastructure/router";
import { WebRoutes } from "consts/enpoints/web";

const ConnectECommercePlatform = () => {
    const navigate = useNavigate();

    const onClick = () => navigate(WebRoutes.ECommerce.Platforms);

    return (
        <Button
            startIcon={(
                <AddShoppingCartIcon />
            )}
            variant='contained'
            onClick={onClick}
        >
            Connect E-Commerce Platform
        </Button>
    );
};

export default ConnectECommercePlatform;
